export const ACCOUNT_DOWNLOAD_TASK_NAME = 'account-download';
export const ACCOUNT_DOWNLOAD_FILE_NAME = 'Account-info-report';
